export const LIST_USERS = 'LIST_USERS';
export const LIST_USERS_LOADING = 'LIST_USERS_LOADING';
export const VALIDATE_USER = 'VALIDATE_USER';
export const CLEAN_USER = 'CLEAN_USER';
export const VALIDATING_USER = 'VALIDATING_USER';
export const LOADING_SAVE_USER_COMPANY = 'LOADING_SAVE_USER_COMPANY';